import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { ConsultaGarantiaModel } from '../models/consulta-garantia';
import { UUID } from 'angular2-uuid';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultaGarantiaService {

  constructor(private httpClient: HttpClient) { }

  public findConsultaGarantiaModel(pConsultaGarantiaModel: ConsultaGarantiaModel): Observable<any> {

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.OcpApimSubscriptionKey)
      .set('Access-Control-Allow-Origin', window.location.href)
      .set('Access-Control-Allow-Header', "*")
      .set('X-RqUID', `${UUID.UUID()}`)
      .set('X-AppId', environment.xAppId)
      .set('X-Channel', environment.xChannel)
      .set('X-CompanyId', environment.xCompanyId)

    return this.httpClient.post(environment.urlApi + environment.backendServicesInquieresGet,
      pConsultaGarantiaModel, { 'headers': headers, observe: "response" });

  }

}
